export default __webpack_public_path__ + "static/media/youtube.9648cdf9.svg";